import styled, { css } from "styled-components";

import {
  QUERIES,
  SPACING,
  SPACING_RESPONSIVE,
} from "../../../../../utils/constants";
import { LiabilitiesFiltersVariant } from "./types";

export const Wrapper = styled.div<{ $variant: LiabilitiesFiltersVariant }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin: 0 ${SPACING_RESPONSIVE.mobile.pageMargin}px;

  @media ${QUERIES.tabletAndUp} {
    margin: 0 ${SPACING_RESPONSIVE.tablet.pageMargin}px;
  }

  @media ${QUERIES.tabletLargeAndUp} {
    margin: 0 ${SPACING_RESPONSIVE.desktop.pageMargin}px;
  }

  ${({ $variant }) =>
    $variant === "inline" &&
    css`
      padding: ${SPACING.md}px ${SPACING.lg}px;
      border-radius: ${SPACING.md}px;
      background: var(--color-background-2);
      border: 1px solid var(--color-border-light);
      box-shadow: var(--shadow-small);
    `}
`;

export const LeftGroup = styled.div<{ $variant: LiabilitiesFiltersVariant }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${SPACING.md}px;

  ${({ $variant }) =>
    $variant === "inline" &&
    css`
      gap: ${SPACING.lg}px;
    `}
`;

export const SelectField = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.sm}px;
`;

export const CountLabel = styled.span`
  font-size: var(--text-base);
  font-style: italic;
  font-weight: var(--font-weight-medium);
  color: var(--color-text-secondary);
  white-space: nowrap;
`;
